export default "__VITE_ASSET__CIRBj$Nz__"